import { LimitPriceInput } from 'components/PlaceOrderLimitPriceInput/LimitPriceInput'
import { useLimitPriceCallback } from 'hooks/spot/useLimitPrice'
import { memo } from 'react'
import { useCreateOrderOption, useCurrentSpotSymbol } from 'store/spot/hooks'
import { Space8 } from 'styles'

export const SpotLimitPriceInput = memo(() => {
  const { limitPrice = '' } = useCreateOrderOption()
  const { quoteCurrency = '', quoteMinimumIncrement = 0 } =
    useCurrentSpotSymbol()
  const { onLimitPriceInput } = useLimitPriceCallback()

  return (
    <>
      <Space8 />
      <LimitPriceInput
        currentPrice={limitPrice}
        quoteCurrency={quoteCurrency}
        quoteMinimumIncrement={quoteMinimumIncrement}
        onChangePrice={onLimitPriceInput}
      />
    </>
  )
})
